module.exports = __webpack_public_path__ + "static/img/sustainable-solutions-ecostruxure-hero.4a65267.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sustainable/sustainable-solutions-ecostruxure-hero.jpg
// module id = svcP
// module chunks = 0